import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useMediaQuery} from 'react-responsive';
import {useHistory} from 'react-router-dom';
import {compose} from 'redux';
import {get} from '../../../api/api';
import {
  uriGetServiceDetails,
  uriGetServices,
  uriGetServicesBO,
} from '../../../api/endpoints';
import AppSpinner from '../../../components/app-spinner';
import Header1 from '../../../components/headers/header1';
import AuthorizedImage from '../../../components/images';
import {Column, Row} from '../../../components/layout';
import {setMedicoOnlineEnabled, setWizard} from '../../../store/actions';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import Bubble from '../../services/bubble';
import MyServicesResponsive from '../../services/my-services-responsive';
import ServiceDetailsModal from '../../services/service-details-modal';
import './styles.scss';

// ir buscar strings ao BO
const labels = strings.pt.services;
interface MyServicesProps {
  selectedBu?: any;
  availableBus?: any;
  wizard?: any;
  buStyles: any;
  setWizard(value: any): void;
  setMedicoOnlineEnabled: Function;
  labels?: typeof strings.pt.services;
  setMedicoOnline(service: any): void;
  setServicesEmpty(value: any): void;
  user: any;
  setMedicOnlineDisabled(value: boolean): void;
}

function MyServices({
  selectedBu,
  labels,
  buStyles,
  setMedicoOnline,
  setServicesEmpty,
  user,
  setMedicOnlineDisabled,
  setMedicoOnlineEnabled,
}: MyServicesProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  function getWindowWidth() {
    const {innerWidth: width, innerHeight: height} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [services, setServices] = useState<any[]>([]);
  const [digitalServices, setDigitalServices] = useState<any[]>([]);
  const [serviceDetails, setServiceDetails] = useState<any>();
  const [loadingInfo, setLoadingInfo] = useState<any>(true);

  const featureName = 'Homepage-MyServices';

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});

  const history = useHistory();

  useEffect(() => {
    const getServices = async () => {
      try {
        await get(
          uriGetServices(selectedBu.buId, selectedBu.prdNbr, selectedBu.benNbr),
          false,
          0,
          featureName
        ).then((res: any) => {
          const aux = res?.data?.items?.find((el: any) => el.isMedicoOnline);
          if (aux) {
            setMedicoOnline(aux);
            setMedicOnlineDisabled(false);
          } else {
            setMedicOnlineDisabled(true);
          }
          setMedicoOnlineEnabled(!!aux);

          // Filter out Medico Online services to now show it on the top of homepage and services twice!
          const filtered = res?.data?.items?.filter(
            (el: any) => /* el.isMedicoOnline || */ el.isDigitalService
          );
          setServices(res?.data?.items);
          setDigitalServices(filtered);
        });
      } catch (err: any) {
        setShowError(true);
      } finally {
        setLoadingInfo(false);
      }
    };
    const getServicesNC = async () => {
      try {
        const finalServices: any[] = [];
        const services: any =
          (await get(uriGetServicesBO(), false, 0, featureName).catch(() => {
            setShowError(true);
          })) || [];
        const activeServices = services?.data?.items?.filter(
          (service: any) =>
            service.status === 'ACTIVE' && service.buAlias === 'NOTCLIENT'
        );
        activeServices.forEach((el: any) => {
          finalServices.push({
            ...el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ),
            serviceId: el.id,
            alias: el.alias,
            displayText: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).serviceName,
            image: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).image,
            listDescription: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).listDescription,
            listDescriptionAPP: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).listDescriptionApp,
            serviceName: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).serviceName,
            isMedicoOnline: el.isMedicoOnline,
            buttonText: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).buttonText,
          });
          const aux = finalServices.find((el: any) => el.isMedicoOnline);
          if (aux) {
            setMedicoOnline(aux);
            setMedicOnlineDisabled(false);
          } else {
            setMedicOnlineDisabled(true);
          }
          setMedicoOnlineEnabled(!!aux);
          const filtered = finalServices.filter(
            (el: any) => el.isMedicoOnline || el.isDigitalService
          );
          setServices(finalServices);
          setDigitalServices(filtered);
        });
      } catch (e: any) {
      } finally {
        setLoadingInfo(false);
      }
    };
    setLoadingInfo(true);
    if (selectedBu.buId === 'NOTCLIENT') {
      getServicesNC();
    } else {
      getServices();
    }
  }, [selectedBu.memId]);

  useEffect(() => {
    services.length === 0 ? setServicesEmpty(true) : setServicesEmpty(false);
  }, [services]);

  const retrieveServiceDetails = async (
    serviceId: any,
    isMedicoOnline: boolean
  ) => {
    if (isMedicoOnline) {
      history.push('/consultas-online');
    } else {
      try {
        await get(uriGetServiceDetails(serviceId), false, 0, featureName).then(
          (details: any) => {
            setServiceDetails(details?.data);
            if (details?.data?.bubbleBehavior === 'link') {
              const bubbleUrl = details?.data?.buServiceDetails.find(
                (detail: any) => detail.languageAlias === user.language
              )?.bubbleUrl;
              if (bubbleUrl) {
                const win = window.open(bubbleUrl, '_blank');
                if (win != null) {
                  win.focus();
                }
              }
            }
          }
        );
      } catch (err: any) {
        setShowError(true);
      }
    }
  };

  return (
    <Column className="services-container">
      <Row className="services-titlerow services-row">
        <Column className="services-titlecolumn">
          <Header1
            className="services-heading1"
            style={{...fonts.XL, ...fonts.Bold}}>
            {labels?.services_title}
          </Header1>
          <div
            className="services-see-all"
            style={{...fonts.MM, ...fonts.Bold, color: buStyles.primaryColor}}
            onClick={() => history.push('/meus-servicos')}>
            {labels?.services_seeAll}
          </div>
        </Column>
      </Row>
      <>
        {windowWidth > 768 ? (
          loadingInfo ? (
            <AppSpinner
              style={{
                width: 'fit-content',
                margin: 'auto',
                marginTop: '5%',
                marginBottom: '10%',
              }}
            />
          ) : (
            <Row className="services-row-images-container">
              {services &&
                services.length !== 0 &&
                Object.keys(digitalServices).map((key: any, index: number) => {
                  if (key < 3)
                    return (
                      <Column
                        key={index}
                        className="services-column-images-container">
                        <Row
                          className="services-row-images-display"
                          onClick={() => {
                            retrieveServiceDetails(
                              digitalServices[key]?.serviceId,
                              digitalServices[key]?.isMedicoOnline
                            );
                            setShow(true);
                          }}>
                          <Bubble
                            classNames={'services-bubble-image'}
                            height={'180px'}
                            width={'180px'}
                          />
                          <AuthorizedImage
                            source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL}${digitalServices[key].image}`}
                            className={
                              digitalServices[key]?.isMedicoOnline
                                ? 'services-images-mo'
                                : 'services-images'
                            }
                          />
                        </Row>
                        <Row
                          className="services-service-info"
                          onClick={() => {
                            retrieveServiceDetails(
                              digitalServices[key]?.serviceId,
                              digitalServices[key]?.isMedicoOnline
                            );
                            setShow(true);
                          }}>
                          <p
                            style={{
                              ...fonts.Bold,
                              ...fonts.L,
                              color: buStyles?.primaryColor,
                            }}
                            className="services-service-info-p">
                            {digitalServices[key].serviceName}
                          </p>
                          <Row className="services-service-info">
                            <p
                              style={{...fonts.M}}
                              className="services-service-info-description-p">
                              {digitalServices[key].listDescription}
                            </p>
                          </Row>
                        </Row>
                      </Column>
                    );
                })}
              {services && services.length === 0 && (
                <Row className="services-more-services-available-title">
                  <p style={{...fonts.M}}>
                    {labels?.services_noServicesAvailable}
                  </p>
                </Row>
              )}
              {services &&
                services.length > 0 &&
                digitalServices.length === 0 && (
                  <Row className="services-more-services-available-title">
                    <p style={{...fonts.M}}>
                      {labels?.services_noDigitalServicesAvailable}
                    </p>
                  </Row>
                )}
            </Row>
          )
        ) : (
          <MyServicesResponsive
            maxItems={3}
            hideList={true}
            setShowError={setShowError}
            setShow={setShow}
            retrieveServiceDetails={retrieveServiceDetails}
            services={services}
          />
        )}
      </>
      <ServiceDetailsModal
        show={show}
        setShow={setShow}
        serviceDetails={serviceDetails}
      />
      {/* <ModalTemplate
        type="error"
        show={showError}
        onHide={() => setShowError(false)}
        hideFooter={true}
        cross={true}>
        <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
          {serviceLabels?.services_error}
        </p>{' '}
      </ModalTemplate> */}
    </Column>
  );
}

const mapStateToProps = ({
  selectedBu,
  strings,
  wizard,
  globalStyles,
  user,
}: any) => ({
  selectedBu: selectedBu.value,
  labels: strings.value.pt.services,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  user: user.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  setMedicoOnlineEnabled: (value: any) =>
    dispatch(setMedicoOnlineEnabled(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MyServices)
);
